import React, { useRef } from "react";
import { URL_LENGTH_LIMIT } from "../MainVideoPage/VideoComponent";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledH5Heading } from "./StyledComponents";

const ShareDialog = ({
    openShareDialog,
    setOpenShareDialog,
    shareLink
    }) => {
    
    const theme = useTheme();
    const textFieldRef = useRef(null);
    const copyShareLink = () => {
        navigator.clipboard.writeText(shareLink);
    }

    return (
        <>
        <Dialog
            open={openShareDialog}
            onClose={() => setOpenShareDialog(false)}
            maxWidth='lg'
        >
        <DialogTitle><StyledH5Heading>Share Link</StyledH5Heading></DialogTitle>
        <DialogContent style={{maxHeight:"450px", maxWidth: "600px", width: "500px", height: "100px"}}>
          {
          shareLink && shareLink.length > URL_LENGTH_LIMIT ? (
            <Typography variant="body1" color="error">
              URL is larger than 2000 characters. Please reduce notes.
            </Typography>
          ) : (
            <TextField
              autoFocus
              margin="dense"
              id="shareLink"
              label="Share Link"
              type="text"
              fullWidth
              variant="standard"
              value={shareLink}
              inputRef={textFieldRef}
              InputProps={{
                readOnly: true,
              }}
            />)
            }
        </DialogContent>
          <DialogActions>
            <Button 
                variant="contained"
                sx={{ paddingTop: "10px" }}
                style={{
                    textTransform: 'capitalize',
                    backgroundColor: theme.palette.primary.main,
                }}
                onClick={copyShareLink}>
                Copy Link
            </Button>
            <Button 
                variant="contained"
                sx={{ paddingTop: "10px", marginRight:"2px"}}
                style={{
                    textTransform: 'capitalize',
                }}
            onClick={() => setOpenShareDialog(false)}>Close</Button>
          </DialogActions>
      </Dialog>
      </>);
}

export default ShareDialog;
